import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'round'
})
export class RoundPipe implements PipeTransform {

    transform(value: number, args?: any): any {
        return Math.round(value)
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/round.pipe.ts